(function () {
  const SELECTORS = {
    builder: '[data-io-builder]',
    list: '[data-io-builder-list]',
    empty: '[data-io-builder-empty]',
    summary: '[data-io-builder-summary]',
    error: '[data-io-builder-error]',
    productForm: '.js-product-form',
    addButton: '[name="add"]',
    dynamicCheckoutContainer: '.product__dynamic-checkout-btn',
    morePaymentOptions: '.shopify-payment-button__more-options, more-payment-options-link a'
  };

  function parseNumber(value) {
    if (value === '' || value == null) return 0;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function clampInteger(value, min = 0) {
    const parsed = Math.floor(parseNumber(value));
    return parsed < min ? min : parsed;
  }

  function getPropertyKeyFromName(name) {
    const match = name.match(/^properties\[(.*)\]$/);
    return match ? match[1] : name;
  }

  function formatFieldLabel(labelText, propertyKey, prefix) {
    const trimmedLabel = (labelText || '').trim();

    if (trimmedLabel) {
      const parts = trimmedLabel.split(' - Size ');
      if (parts.length > 1) {
        return parts.slice(1).join(' - Size ').trim();
      }

      return trimmedLabel;
    }

    return propertyKey.replace(prefix, '').replace(/_/g, ' ').trim();
  }

  function getMatchingFields(prefix) {
    console.log('getmatchingfields', prefix)
    const container = document.getElementById('infiniteoptions-container');
    console.log(container)
    if (!container) return [];

    console.log(container.querySelectorAll('input[type="number"][name^="properties["]'))
    const inputs = Array.from(
      container.querySelectorAll('input[type="number"][name^="properties["]')
    );
    console.log(inputs);

    return inputs
      .map((input) => {
        const propertyKey = getPropertyKeyFromName(input.name);

        console.log(propertyKey, prefix);

        if (!propertyKey.startsWith(prefix)) return null;

        const row = input.closest('#infiniteoptions-container > div');
        const label = row ? row.querySelector('label') : null;

        return {
          input,
          row,
          label,
          propertyKey,
          labelText: formatFieldLabel(label ? label.textContent : '', propertyKey, prefix)
        };
      })
      .filter(Boolean);
  }

  function getProductForm(builder) {
    const productFormId = builder.dataset.productFormId;
    if (productFormId) {
      const formById = document.getElementById(productFormId);
      if (formById) return formById;
    }

    return builder.closest('.product-info')?.querySelector(SELECTORS.productForm) || document.querySelector(SELECTORS.productForm);
  }

  function getPurchaseTargets(form) {
    const wrapper = form.closest('product-form') || form.parentElement || document;
    const addButton = form.querySelector(SELECTORS.addButton);
    const dynamicCheckoutContainer = wrapper.querySelector(SELECTORS.dynamicCheckoutContainer);
    const morePaymentOptions = wrapper.querySelector(SELECTORS.morePaymentOptions);

    return {
      addButton,
      dynamicCheckoutContainer,
      morePaymentOptions
    };
  }

  function setPurchaseState(form, isValid) {
    const { addButton, dynamicCheckoutContainer, morePaymentOptions } = getPurchaseTargets(form);

    if (addButton) {
      if (isValid) {
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('aria-disabled');
        addButton.classList.remove('io-builder__purchase-disabled');
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('aria-disabled', 'true');
        addButton.classList.add('io-builder__purchase-disabled');
      }
    }

    if (dynamicCheckoutContainer) {
      dynamicCheckoutContainer.classList.toggle('io-builder__purchase-disabled', !isValid);
      dynamicCheckoutContainer.setAttribute('aria-hidden', isValid ? 'false' : 'true');
    }

    if (morePaymentOptions) {
      morePaymentOptions.classList.toggle('io-builder__purchase-disabled', !isValid);
      if (!isValid) {
        morePaymentOptions.setAttribute('tabindex', '-1');
        morePaymentOptions.setAttribute('aria-disabled', 'true');
      } else {
        morePaymentOptions.removeAttribute('tabindex');
        morePaymentOptions.removeAttribute('aria-disabled');
      }
    }
  }

  function getTotal(fields) {
    return fields.reduce((sum, field) => sum + clampInteger(field.input.value, 0), 0);
  }

  function buildSummaryText(total, requiredAmount, restrictionType) {
    if (restrictionType === 'lte') {
      return `Selected ${total} of up to ${requiredAmount}.`;
    }

    return `Selected ${total} of ${requiredAmount}.`;
  }

  function buildErrorText(total, requiredAmount, restrictionType) {
    if (restrictionType === 'lte') {
      if (total > requiredAmount) {
        const overBy = total - requiredAmount;
        return `Remove ${overBy} item${overBy === 1 ? '' : 's'}.`;
      }

      return '';
    }

    if (total < requiredAmount) {
      const remaining = requiredAmount - total;
      return `Choose ${remaining} more item${remaining === 1 ? '' : 's'}.`;
    }

    if (total > requiredAmount) {
      const overBy = total - requiredAmount;
      return `Remove ${overBy} item${overBy === 1 ? '' : 's'}.`;
    }

    return '';
  }

  function isValidSelection(total, requiredAmount, restrictionType) {
    if (restrictionType === 'lte') {
      return total <= requiredAmount;
    }

    return total === requiredAmount;
  }

  function normalizeInput(input) {
    input.step = '1';
    input.min = '0';

    if (input.value === '') {
      input.value = '0';
    } else {
      input.value = String(clampInteger(input.value, 0));
    }
  }

  function restructureField(field) {
    if (!field.row || !field.label) return;

    field.row.classList.add('io-builder__row');

    field.label.classList.add('io-builder__label');

    const labelTooltip = field.row.querySelector('.spb-label-tooltip');
    if (labelTooltip) {
      labelTooltip.classList.add('io-builder__label-wrap');
    }

    const currentInputWrap = field.input.parentElement;
    if (currentInputWrap) {
      currentInputWrap.classList.add('io-builder__input-wrap');
    }

    field.label.textContent = field.labelText;
    normalizeInput(field.input);
  }

  function updateState(builder, form, fields, requiredAmount, restrictionType) {
    const summaryEl = builder.querySelector(SELECTORS.summary);
    const errorEl = builder.querySelector(SELECTORS.error);
    const total = getTotal(fields);
    const valid = isValidSelection(total, requiredAmount, restrictionType);
    const errorText = buildErrorText(total, requiredAmount, restrictionType);

    if (summaryEl) {
      summaryEl.textContent = buildSummaryText(total, requiredAmount, restrictionType);
      summaryEl.classList.toggle('is-valid', valid);
      summaryEl.classList.toggle('is-invalid', !valid);
    }

    if (errorEl) {
      errorEl.hidden = valid || !errorText;
      errorEl.textContent = errorText;
    }

    if (form) {
      setPurchaseState(form, valid);
    }
  }

  function initBuilder(builder) {
  if (builder.dataset.ioBuilderInitialized === 'true') return;

  const prefix = (builder.dataset.fieldPrefix || '').trim();
  const requiredAmount = Number(builder.dataset.requiredAmount || 0);
  const restrictionType = builder.dataset.restrictionType || 'exact';

  if (!prefix || !requiredAmount) return;

  const form = getProductForm(builder);
  const list = builder.querySelector(SELECTORS.list);
  const empty = builder.querySelector(SELECTORS.empty);

  if (!form || !list) return;

  waitForMatchingInfiniteOptionsFields(prefix, () => {
    if (builder.dataset.ioBuilderInitialized === 'true') return;

    const fields = getMatchingFields(prefix);

    if (!fields.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    fields.forEach((field) => {
      restructureField(field);
      list.appendChild(field.row);

      field.input.addEventListener('input', () => {
        field.input.value = String(clampInteger(field.input.value, 0));
        updateState(builder, form, fields, requiredAmount, restrictionType);
      });

      field.input.addEventListener('change', () => {
        field.input.value = String(clampInteger(field.input.value, 0));
        updateState(builder, form, fields, requiredAmount, restrictionType);
      });
    });

    form.addEventListener('submit', (event) => {
      const total = getTotal(fields);
      const valid = isValidSelection(total, requiredAmount, restrictionType);

      if (!valid) {
        event.preventDefault();
        event.stopPropagation();
        updateState(builder, form, fields, requiredAmount, restrictionType);

        const firstInput = fields[0] && fields[0].input;
        if (firstInput) firstInput.focus();
      }
    });

    updateState(builder, form, fields, requiredAmount, restrictionType);
    builder.dataset.ioBuilderInitialized = 'true';
  });
}

  function initAllBuilders(root = document) {
    const builders = root.querySelectorAll(SELECTORS.builder);
    builders.forEach(initBuilder);
  }

function waitForMatchingInfiniteOptionsFields(prefix, callback) {
  const container = document.getElementById('infiniteoptions-container');
  if (!container) return;

  const hasMatchingFields = () => {
    const inputs = container.querySelectorAll('input[type="number"][name^="properties["]');
    return Array.from(inputs).some((input) => {
      const propertyKey = getPropertyKeyFromName(input.name);
      return propertyKey.startsWith(prefix);
    });
  };

  if (hasMatchingFields()) {
    callback();
    return;
  }

  const observer = new MutationObserver(() => {
    if (hasMatchingFields()) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllBuilders(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initAllBuilders(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  initAllBuilders(event.target);
});
})();